import axios from 'axios';
import moment from 'moment';

export const namespaced = true;

export const state = {
    allTestkits: [],
    currentPageNumber: null,
    endDate: null,
    rowsToDisplay: null,
    selectedCaseTestKitData: [],
    startDate: null,
    testKits: [],
    totalItems: null,
    totalPaginationPages: null,
    previousQuery: null
}

export const actions = {

    async fetchTestKits({ rootState }, searchObj) {
      
        var apiUrl = "";
        if (searchObj.refreshData) {
            apiUrl = state.previousQuery;
        }
        else {
            let caseId = searchObj.caseId;
            let startDate = searchObj.startDate;
            let endDate = searchObj.endDate
            if (endDate) {
                endDate = moment(searchObj.endDate, 'YYYY-MM-DD');
            }
            let pageSize = searchObj.rowsToDisplay;
            let pageNumber = searchObj.currentPageNumber;
            let searchUrl = ''; //prefixurlprod
            if (caseId?.length > 0) {
                searchUrl += '?id=' + caseId;
            }
            else {
                if (startDate?.diff(endDate, 'days') == 0) endDate.add(1, 'days');

                if (startDate?._isValid) {
                    searchUrl += searchUrl.includes('?') ? '&' : '?';
                    searchUrl += 'startDate=' + startDate.format('YYYY-MM-DD');
                }
                if (endDate?._isValid) {
                    searchUrl += searchUrl.includes('?') ? '&' : '?';
                    searchUrl += 'endDate=' + endDate.format('YYYY-MM-DD');
                }
            }

            searchUrl += searchUrl.includes('?') ? '&' : '?';
            searchUrl += `pageSize=${pageSize}`;
            if (pageNumber >= 0) {
                searchUrl += '&pageNumber=' + (parseInt(pageNumber) - 1);
            }
            // searchUrl += '&sort=DESC';

            apiUrl = `${rootState.baseUrlApiDvg}/healthcheck-restful-api/patienttestkit` + searchUrl;
            // apiUrl = `http://localhost:8082/healthcheck-restful-api/patienttestkit` + searchUrl;
            //apiUrl = 'https://api.dvgapp.org/healthcheck-restful-api/patienttestkit' + searchUrl; console.log(rootState); // Test with prod url for more results.
            state.previousQuery = apiUrl;
        }

        return await axios.get(apiUrl) //?id=88d4acb6-8814-4296-bd32-aa79cf4bf670`) // + caseId)
            .then((res) => {
                if (res.data.dataSetRowCount == 0) return null;
                return res;
            })
            .catch((error) => {
                console.log(error);
                throw new Error(error);
            });
    },

    async getPatientTestKitInfo({ rootState, commit, dispatch }, caseId) {
        // .get(`http://localhost:8082/healthcheck-restful-api/patienttestkit/${caseId}`)
        return await axios
        .get(`${rootState.baseUrlApiDvg}/healthcheck-restful-api/patienttestkit/${caseId}`)
            .then(res => {
                if (res.status == 200) commit('SET_SUBJECT_CASE_TESTKIT_INFO', res.data);
                return res.data;
            })
            .catch(error => {
                console.log(error);
                dispatch('showError', 'Error loading test kit info', { root: true });
            });
    },

    async updatePatientTestKitInfo({ rootState, dispatch }, payload) {
        return await axios
            .put(`${rootState.baseUrlApiDvg}/healthcheck-restful-api/patienttestkit/${payload.id}`, payload)
            .then(res => {
                return res.data;
            })
            .catch(error => {
                console.log(error);
                dispatch('showError', 'Error saving payment type test kit', { root: true });
            });
    },

    async downloadTestkitCertificate({ rootState, dispatch }, payload) {
        return await axios
            .get(`${rootState.baseUrlApiDvg}/healthcheck-restful-api/patienttestkit/${payload.caseId}/${payload.teskKitNumber}`, {
                responseType: 'arraybuffer'
            })
            .then(res => {
                if (res.status == 200) {
                    const url = window.URL.createObjectURL(new Blob([res.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'TESTKIT-CERTIFICATE-' + payload.teskKitNumber + '.pdf');
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    return true;
                } else {
                    dispatch('showError', 'Error downloading covid test certificate', { root: true });
                }
            })
            .catch(error => {
                console.log(error);
                dispatch('showError', 'Error downloading covid test certificate', { root: true });
            });
    },

    async deleteTestkit({ rootState, commit }, id) {
        return await axios
            .delete(`${rootState.baseUrlApiDvg}/healthcheck-restful-api/patienttestkit/${id}`)
            //.delete(`http://localhost:8082/healthcheck-restful-api/patienttestkit/${id}`)
            .then(res => {
                if (res.status == 200 || res.status == 204) {
                    return true;
                }
            })
            .catch(error => {
                console.log(error);
                let payload = {
                    open: true,
                    text: 'Error deleting test kit',
                    color: 'error'
                };
                commit('SET_SNACKBAR', payload);
            });
    },
}

export const mutations = {
    SET_SUBJECT_CASE_TESTKIT_INFO(state, payload) {
        let testKitData = payload.map(item => {
            item.loading = false;
            return item;
        });

        state.selectedCaseTestKitData = testKitData;
    },

    SET_TESTKIT_RESULT_DOWNLOAD_LOADING(state, payload) {
        for (var i = 0; i < state.selectedCaseTestKitData.length; i++) {
            if (state.selectedCaseTestKitData[i].id == payload.kitId) {
                state.selectedCaseTestKitData[i].loading = payload.action;
                return;
            }
        }
    },
}